import '../../styles/web-components/toggle-module.scss';
import '../../styles/templates/_collection-v2.scss';
import { getAlternateTemplate } from '../services/template.service';
import { refreshWishlistIcons } from '../services/wishlist.service';
import Splide from "@splidejs/splide";
import { DESKTOP_WIDTH, TABLET_WIDTH } from '../constants/devices.constants';
import { updateArrowPosition } from '../helpers/carousel-utils';
const defaultCarouselOptions = {
    mediaQuery: "min",
    gap: "8px",
    type: 'slide',
    perPage: 2,
    arrows: false,
    pagination: false,
    padding: { right: "5%" },
    breakpoints: {
        [TABLET_WIDTH]: {
            perPage: 3
        },
        [DESKTOP_WIDTH]: {
            perPage: 4,
            gap: "24px",
            arrows: true,
            padding: { right: "0" },
        }
    }
};
class ToggleModule extends HTMLElement {
    static get observedAttributes() {
        return ["selected-cta-index"];
    }
    carousel = null;
    loadingSpinner = null;
    numProducts = +this.getAttribute('num-products') || 6;
    constructor() {
        super();
        this.addEventListener('click', async (e) => {
            const target = e.target;
            if (target.matches(".toggle-module__navigation-item:not(.toggle-module__navigation-item--selected)")) {
                // eslint-disable-next-line wc/no-constructor-attributes
                this.setAttribute('selected-cta-index', target.dataset.ctaIndex);
            }
        });
        this.addEventListener("click", async (e) => {
            const target = e.target;
            if (target.matches(".js-product-option:not(.product-option--selected)")) {
                e.stopPropagation();
                const initialColorSwatches = target.closest(".product-grid-item-v2__product-swatch-container");
                if (initialColorSwatches) {
                    initialColorSwatches.querySelectorAll(".js-product-option").forEach(c => c.classList.remove("product-option--selected"));
                    target.classList.add("product-option--selected");
                    const initialScrollLeft = initialColorSwatches.scrollLeft;
                    const collectionHandle = target.closest('.js-collection-render-test-result').dataset.collectionHandle;
                    const productHandle = target.dataset.productHandle;
                    const productCardHTML = await getAlternateTemplate(`/collections/${collectionHandle}/products/${productHandle}`, 'plp-card');
                    const productCardEl = target.closest(".boost-pfs-filter-product-item");
                    productCardEl.innerHTML = productCardHTML;
                    const newColorSwatches = productCardEl.querySelector('.product-grid-item-v2__product-swatch-container');
                    newColorSwatches.replaceWith(initialColorSwatches);
                    initialColorSwatches.scrollTo(initialScrollLeft, 0);
                    productCardEl.querySelectorAll('img[data-src]').forEach(img => {
                        img.src = img.dataset.src;
                        img.srcset = img.dataset.srcset || '';
                        img.removeAttribute('data-srcset');
                        img.removeAttribute('data-src');
                    });
                    refreshWishlistIcons('.boost-pfs-filter-products');
                }
            }
        });
        window.addEventListener('resize', () => {
            updateArrowPosition(this.carousel);
        });
    }
    connectedCallback() {
        this.loadingSpinner = this.querySelector('loading-spinner');
        this.carousel = new Splide(this.querySelector('.splide'), defaultCarouselOptions);
        this.carousel.mount();
        const firstCta = this.querySelector('.toggle-module__navigation-item');
        if (firstCta) {
            this.fetchAndRenderCollection(firstCta.dataset.ctaIndex);
        }
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.carousel || oldValue === newValue)
            return;
        switch (name) {
            case 'selected-cta-index':
                this.fetchAndRenderCollection(newValue);
                break;
            default:
                break;
        }
    }
    async fetchAndRenderCollection(ctaIndex) {
        console.log('CTA Index:', ctaIndex);
        const contentEl = this.querySelector('.toggle-module__content');
        contentEl?.classList.add('toggle-module__content--loading');
        this.loadingSpinner?.setAttribute('show', 'true');
        try {
            let selectedCta = null;
            this.querySelectorAll('.toggle-module__navigation-item').forEach(c => {
                if (c.dataset.ctaIndex === ctaIndex) {
                    c.classList.add('toggle-module__navigation-item--selected');
                    selectedCta = c;
                }
                else {
                    c.classList.remove('toggle-module__navigation-item--selected');
                }
            });
            if (!selectedCta)
                return;
            const collectionHandle = selectedCta.dataset.collectionHandle;
            const resp = await fetch(`/collections/${collectionHandle}?sections=collection-product-cards`);
            const json = await resp.json();
            const parser = new DOMParser();
            const doc = parser.parseFromString(json['collection-product-cards'], 'text/html');
            const styles = new Set(doc.querySelectorAll('link[rel="stylesheet"]'));
            styles.forEach(style => {
                if (!document.head.querySelector(`link[href="${style.href.replace("https:", "")}"]`)) {
                    document.head.appendChild(style);
                }
            });
            const productList = Array.from(doc.querySelectorAll(".boost-pfs-filter-product-item")).slice(0, this.numProducts).map(el => {
                const li = document.createElement('li');
                li.className = 'splide__slide';
                li.appendChild(el);
                return li;
            });
            const results = this.querySelector('.splide ul');
            results.replaceChildren(...productList);
            results.dataset.collectionHandle = collectionHandle;
            results.querySelectorAll('img[data-src]').forEach((img, i) => {
                if (i === 0) {
                    img.addEventListener('load', () => {
                        updateArrowPosition(this.carousel);
                    }, { once: true });
                }
                img.src = img.dataset.src;
                img.srcset = img.dataset.srcset || '';
                img.removeAttribute('data-srcset');
                img.removeAttribute('data-src');
            });
            this.carousel?.refresh().go(0);
            refreshWishlistIcons('.boost-pfs-filter-products');
        }
        finally {
            contentEl?.classList.remove('toggle-module__content--loading');
            this.loadingSpinner?.setAttribute('show', 'false');
        }
    }
}
if (!window.customElements.get("toggle-module")) {
    customElements.define("toggle-module", ToggleModule);
}
